export default "__VITE_PUBLIC_ASSET__be826360__"